// components/leads/LeadKanbanView.js
// Vista Kanban dei lead - riceve drag props dal parent

import React from 'react';
import { Badge } from '../ui/badge';
import { XCircle, UserPlus, PhoneCall, User, Calendar, Eye, FileText, Handshake, Building, CheckCircle } from 'lucide-react';
import { useDroppable } from '@dnd-kit/core';

const workflowSteps = [
  { status: 'nuovo', label: 'Nuovo', icon: UserPlus, color: 'bg-blue-500' },
  { status: 'contattato', label: 'Contattato', icon: PhoneCall, color: 'bg-cyan-500' },
  { status: 'assegnato', label: 'Assegnato', icon: User, color: 'bg-indigo-500' },
  { status: 'appuntamento_fissato', label: 'Appuntamento', icon: Calendar, color: 'bg-purple-500' },
  { status: 'sopralluogo_effettuato', label: 'Sopralluogo', icon: Eye, color: 'bg-violet-500' },
  { status: 'in_preventivazione', label: 'Preventivazione', icon: FileText, color: 'bg-amber-500' },
  { status: 'preventivo_presentato', label: 'Presentato', icon: FileText, color: 'bg-orange-500' },
  { status: 'in_trattativa', label: 'Trattativa', icon: Handshake, color: 'bg-rose-500' },
  { status: 'in_contratto', label: 'Contratto', icon: Building, color: 'bg-emerald-500' },
  { status: 'convertito', label: 'Convertito', icon: CheckCircle, color: 'bg-green-600' },
];

// Colonna Droppable
const DroppableColumn = ({ status, label, icon: Icon, color, leads, LeadCardComponent, isLostColumn }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `column-${status}`,
    data: { type: 'column', status },
  });

  return (
    <div 
      className="w-80 flex-shrink-0"
      data-testid={`kanban-column-${status}`}
    >
      {/* Column Header */}
      <div className={`rounded-t-xl p-3 ${color}`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-white">
            <Icon className="w-4 h-4" />
            <span className="font-medium text-sm">{label}</span>
          </div>
          <Badge className="bg-white/20 text-white text-xs">
            {leads.length}
          </Badge>
        </div>
      </div>
      
      {/* Column Body - Droppable Area */}
      <div 
        ref={setNodeRef}
        className={`rounded-b-xl p-3 min-h-[450px] space-y-3 transition-all ${
          isLostColumn ? 'bg-red-50' : 'bg-gray-50'
        } ${isOver ? 'bg-orange-100 ring-2 ring-[#FF7819] ring-inset' : ''}`}
      >
        {leads.length === 0 ? (
          <div className={`text-center py-8 ${isOver ? 'text-[#FF7819]' : 'text-[#999]'}`}>
            <p className="text-sm">{isOver ? 'Rilascia qui' : 'Nessun lead'}</p>
          </div>
        ) : (
          leads.map(lead => (
            <LeadCardComponent key={lead.id} lead={lead} compact />
          ))
        )}
      </div>
    </div>
  );
};

const LeadKanbanView = ({ 
  leadsByStatus, 
  LeadCardComponent,
  isDragEnabled = false,
}) => {
  return (
    <div className="overflow-x-auto pb-4">
      <div className="flex gap-4 min-w-max">
        {workflowSteps.map((step) => {
          const stageLeads = leadsByStatus[step.status] || [];
          
          return (
            <DroppableColumn
              key={step.status}
              status={step.status}
              label={step.label}
              icon={step.icon}
              color={step.color}
              leads={stageLeads}
              LeadCardComponent={LeadCardComponent}
              isLostColumn={false}
            />
          );
        })}
        
        {/* Colonna Persi */}
        <DroppableColumn
          status="perso"
          label="Persi"
          icon={XCircle}
          color="bg-red-500"
          leads={[...(leadsByStatus['non_risponde'] || []), ...(leadsByStatus['perso'] || [])]}
          LeadCardComponent={LeadCardComponent}
          isLostColumn={true}
        />
      </div>
    </div>
  );
};

export default LeadKanbanView;
